/*
 * @Description: 核对订单、订单列表等商品项
 */
import React, { Component } from 'react';
import { Flex, Modal } from 'antd-mobile';
import Util from 'utils';
import { observer, inject } from 'mobx-react';
import { PriceText } from 'widget';
import Stores from 'config/Stores';
import cx from 'classnames';
import styles from './index.modules.less';
import { ImgWrap } from 'pubBiz';

@inject('AppMod')
@observer
export default class OrderProductItemView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modal2: false,
      list: []
    };
  }

  render() {
    const { isWDY } = Stores.AppMod;
    // 通用组件，修改字段时注意做下兼容
    const {
      data,
      isGift = false,
      discount,
      activityGoodsInfo,
      groupBookingReqDto,
      hiddenBv,
      isSelectMall
    } = this.props;
    const {
      imgUrl,
      imageUrl,
      itemName,
      code,
      itemCode,
      bv,
      itemPrice,
      originalPrice,
      itemNum,
      child,
      retailBv,
      retailPrice,
      itemSerial,
      isTakeGuide,
      integration,
      beanItemNum, //三生豆数量
      groupKey,
      discountPrice
    } = data;
    const combinationList = child; // 套装
    const { activityType, discountSalePrice } = activityGoodsInfo || {};
    const {
      groupSendFailAmount, // groupSendFailAmount:红包金额;
      groupSendType, // groupSendType :抢购选择方式：0 随机分配 1 优先未中;
      groupType, // groupType : 拼团类型,0 普通拼团 1 拼团抢购
      groupMemberSuccessCount // groupMemberSuccessCount :拼团抢购成功人数
    } = groupBookingReqDto || {};
    // 顺手买一单的产品
    const isEaseBuyItem = groupKey === '-1';
    const specialShow = groupType === 1; // 判断是否是拼团抢购
    const showPrice =
      +activityType === 8
        ? discountSalePrice
        : discount
          ? retailPrice
          : isEaseBuyItem
            ? discountPrice
            : itemPrice;
    return (
      <Flex
        direction="column"
        justify="start"
        align="start"
        className={styles['order-product-item']}
        onClick={() => this.props.onClick && this.props.onClick()}>
        <Flex className={styles['order-product-main']}>
          <img
            src={imgUrl || imageUrl ? Util.getImgUrl(imgUrl || imageUrl, 160) : ''}
            alt="商品图片"
          />
          <Flex direction="column" justify="between" align="start" className={styles['base-info']}>
            <Flex align="start" direction="column" style={{ width: '100%' }}>
              <span className={cx('fz-28', 'ellipsis', styles.name)}>{itemName}</span>
              {specialShow && (
                <Flex>
                  <span
                    className={cx(
                      'fz-28',
                      'ellipsis',
                      styles.tag
                    )}>{`${groupMemberSuccessCount}人抢购成功`}</span>
                  <span
                    className={cx(
                      'fz-22',
                      styles['back_return']
                    )}>{`拼不中参与红包：${Util.formatMoney({ value: groupSendFailAmount, precision: 0 })}`}</span>
                </Flex>
              )}
              <span className={cx('fz-22', 'color-light-grey', styles['margin-top'])}>
                {code || itemCode}
              </span>
            </Flex>

            <Flex
              className={styles['margin-top']}
              wrap="wrap"
              justify="between"
              align="center"
              style={{ width: '100%', lineHeight: '0.4rem' }}>
              {!isGift && (
                <Flex align="center" className={styles['margin-top']}>
                  {!isSelectMall && (
                    <PriceText
                      className={styles['price-text']}
                      unitClassName={styles['size-big']}
                      integerClassName={styles['size-big']}
                      decimalClassName={styles['size-big']}
                      value={showPrice}
                      showSymbol={false}
                      showIcon
                    />
                  )}
                  {originalPrice && (
                    <span
                      className={cx('fz-22', 'color-light-grey', 'fz-through')}
                      style={{ marginLeft: '10px' }}>
                      {Util.formatMoney(originalPrice)}
                    </span>
                  )}
                  {!isGift &&
                    !hiddenBv &&
                    this.props.AppMod.userType != 1 &&
                    !this.props.AppMod.isLY && (
                      <span
                        className={cx('fz-22', 'color-light-grey')}
                        style={{ marginLeft: isSelectMall ? 0 : 20 }}>
                        BV： {discount ? Util.parInt(retailBv) : Util.parInt(bv)}
                      </span>
                    )}
                  {beanItemNum > 0 && (
                    <Flex
                      direction="row"
                      align="center"
                      justify="center"
                      className={styles['product-bean']}>
                      <p className={styles['plus-icon']}>+</p>
                      <img
                        src={`${CDN_BASE}/assets/imgs/clock/bean_active.png`}
                        className={styles['bean-icon']}
                      />
                      <p className={styles['bean-num']}>{beanItemNum}</p>
                    </Flex>
                  )}
                </Flex>
              )}
              {isSelectMall && (
                <span
                  className={cx(
                    'fz-22',
                    'color-light-grey',
                    'margin-top'
                  )}>{`${this.props.AppMod.selectMallCoinLabel}：${integration}`}</span>
              )}
              {this.props.takeShow && isTakeGuide && (
                <Flex
                  align="center"
                  className={cx('margin-top', styles['guide-text'])}
                  onClick={async (e) => {
                    e.stopPropagation();
                    let list = await this.props.AppMod.guidelines(itemSerial);
                    this.setState({
                      modal2: true,
                      list
                    });
                  }}>
                  产品服务指南 <i className={cx('iconfont', 'icon-arrow-right', styles.guide)} />
                </Flex>
              )}
            </Flex>
          </Flex>
          {!this.props.notShowNum && <span className={cx('fz-24', 'color-gray')}>x{itemNum}</span>}
        </Flex>

        {!isWDY && combinationList && combinationList.length > 0 && (
          <div className={styles['combination-list-wrap']}>
            <div className={styles['combination-list-header']}>
              <div className={styles['line']}></div>
              <span>套餐包含</span>
              <div className={styles['line']}></div>
            </div>
            {!isWDY &&
              combinationList &&
              combinationList.map((item, index) => {
                const {
                  imgUrl,
                  imageUrl,
                  itemName,
                  code,
                  itemCode,
                  itemNum: itmes,
                  itemUnit,
                  unit,
                  itemType
                } = item;
                const isVirtualGoods = [3, 4].includes(Number(itemType));
                return (
                  <Flex
                    key={`combination-list-item${index}`}
                    className={styles['combination-list-item']}>
                    <img
                      src={imgUrl || imageUrl ? Util.getImgUrl(imgUrl || imageUrl, 128) : ''}
                      alt="商品图片"
                    />
                    <Flex
                      direction="column"
                      justify="between"
                      align="start"
                      className={styles['base-info']}>
                      <span className={cx('ellipsis', styles.itemName)} style={{ width: '100%' }}>
                        {itemName}
                      </span>
                      <Flex className={styles['base-info-footer']}>
                        <span className={cx('fz-24', 'color-light-grey')}>{code || itemCode}</span>
                        <span className={cx('fz-24', 'color-grey')}>
                          x
                          {`${(itemNum || 1) * (itmes || 1)}${isVirtualGoods ? '' : itemUnit || unit || ''}`}
                        </span>
                      </Flex>
                    </Flex>
                  </Flex>
                );
              })}
          </div>
        )}
        <Modal
          popup
          closable={false}
          visible={this.state.modal2}
          onClose={(e) => {
            e.stopPropagation();
            this.setState({
              modal2: false
            });
          }}
          className={styles['take-modal']}
          animationType="slide-up">
          <Flex style={{ width: '100%', height: '20px' }} />
          <Flex
            align="center"
            justify="between"
            style={{ padding: '0 0.3rem' }}
            className={styles['modal-title']}>
            <span style={{ margin: '0 auto' }}>服用指南</span>
            <div onClick={() => this.setState({ modal2: false })}>
              <ImgWrap
                src={`${CDN_BASE}/assets/imgs/common/close_emp.png` || ''}
                className="flex-end"
                mode="full"
                w="0.28rem"
                h="0.28rem"
              />
            </div>
          </Flex>
          {this.state.list &&
            this.state.list.length > 0 &&
            this.state.list.map((listItem, listItemIndex) => {
              return (
                <div key={listItemIndex} className={styles.spaceViwe}>
                  <div className={styles['space-title']}>{listItem.title}</div>
                  <div className={styles['space-right']}>{listItem.recommendations}</div>
                </div>
              );
            })}
        </Modal>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/OrderProductItem/index.js